import http from './http'

export function uploadVendorAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post('/api/avatar/vendor', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function uploadAdminAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post('/api/avatar/admin', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function avatarAssetUrl(value) {
  if (!value) return ''
  if (value.startsWith('/api/')) return `${http.defaults.baseURL}${value}`
  return value
}
